// Enums need sync with admin-crm\src\pages-export\market-tool-report\components\AbTesting\constants\index.js

export const AbTemplateDisplayPage = Object.freeze({
  OPEN_LIVE_ACCOUNT_AA: 'Open Live Account',
  OPEN_LIVE_ACCOUNT_AAA: 'Open Additional Account',
  POP_UP: 'Pop up',
})

export const AbTemplateRule = Object.freeze({
  CLICKED: 'Clicked',
  UN_CLICKED: 'UnClicked',
})
